import {Component, OnInit} from '@angular/core';
import {SpThemingService} from '../../../../services/sp-theming/sp-theming.service';
import {AudienceImportType} from '../../../../services/sp-facebook/facebook-link.service';
import { MatDialog } from '@angular/material/dialog';
import {Message} from 'primeng/api';
import {NavigationService} from '../../../../services/sp-navigation/navigation.service';
import {
  AudienceCreationMode,
  AudienceType,
  ProjectCreationManagerService
} from '../../../../services/sp-project/project-creation-manager.service';

@Component({
  selector: 'app-sp-project-create-facebook-page',
  templateUrl: './sp-project-create-facebook-page.component.html',
  styleUrls: ['./sp-project-create-facebook-page.component.scss']
})
export class SpProjectCreateFacebookPageComponent implements OnInit {
  // Searching and filtering
  hideScroll = false;
  // Notifications
  msgs: Message[] = [];

  // Constructor.
  constructor(private _spTheming: SpThemingService,
              public projectCreationManager: ProjectCreationManagerService,
              private navigation: NavigationService,
              private dialog: MatDialog) {
    // Set the theme to use.
    this._spTheming.setSpThemeName('dashboard-desk');
    projectCreationManager.reset(AudienceType.target, AudienceCreationMode.import);
    projectCreationManager.switchAudienceType(AudienceType.target);
    projectCreationManager.switchAudienceMode(AudienceCreationMode.facebookPage);
  }

  // On init.
  ngOnInit() {
    this.navigation.adBlockDetectionLaunch().then();
  }

  ngOnDestroy() {
  }

  showError(errorName) {
    this.msgs = [];
    this.msgs.push({severity:'error', summary:'Error Message', detail: errorName});
  }

  get AudienceImportType(): typeof AudienceImportType { return AudienceImportType; }
}
